import Choices from "choices.js";

export class ChoicesFactory {
    static create(el, options = {}) {
        const choice = new Choices(el, {
            noResultsText: "Ничего не найдено",
            itemSelectText: "",
            allowHTML: true,
            searchEnabled: false,
            searchChoices: false,
            ...options,
        });
        el.addEventListener("setChoiceValueByLabel", (event) => {
            if (event.detail) {
                const select = choice.config.choices.filter(item => item.label.trim() === event.detail)[0];
                if (select) {
                    choice.setChoiceByValue(select.value);
                    el.dispatchEvent(new Event("setFilled"));
                }
            }
        });
        return choice;
    }
}

document.querySelectorAll(".js-select").forEach((el) => ChoicesFactory.create(el));
